export default __webpack_public_path__ + "static/media/01_DAIF_Data_03_01_end.a38e4e6e.jpg";